"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_CONNECTION_STATUS = void 0;
exports["default"] = updateConnectionStatus;
var UPDATE_CONNECTION_STATUS = 'DIRECT_LINE/UPDATE_CONNECTION_STATUS';
exports.UPDATE_CONNECTION_STATUS = UPDATE_CONNECTION_STATUS;
function updateConnectionStatus(connectionStatus) {
  return {
    type: UPDATE_CONNECTION_STATUS,
    payload: {
      connectionStatus: connectionStatus
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJVUERBVEVfQ09OTkVDVElPTl9TVEFUVVMiLCJleHBvcnRzIiwidXBkYXRlQ29ubmVjdGlvblN0YXR1cyIsImNvbm5lY3Rpb25TdGF0dXMiLCJ0eXBlIiwicGF5bG9hZCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3VwZGF0ZUNvbm5lY3Rpb25TdGF0dXMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgVVBEQVRFX0NPTk5FQ1RJT05fU1RBVFVTID0gJ0RJUkVDVF9MSU5FL1VQREFURV9DT05ORUNUSU9OX1NUQVRVUyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVwZGF0ZUNvbm5lY3Rpb25TdGF0dXMoY29ubmVjdGlvblN0YXR1cykge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFVQREFURV9DT05ORUNUSU9OX1NUQVRVUyxcbiAgICBwYXlsb2FkOiB7IGNvbm5lY3Rpb25TdGF0dXMgfVxuICB9O1xufVxuXG5leHBvcnQgeyBVUERBVEVfQ09OTkVDVElPTl9TVEFUVVMgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLHdCQUF3QixHQUFHLHNDQUFzQztBQUFDQyxPQUFBLENBQUFELHdCQUFBLEdBQUFBLHdCQUFBO0FBRXpELFNBQVNFLHNCQUFzQkEsQ0FBQ0MsZ0JBQWdCLEVBQUU7RUFDL0QsT0FBTztJQUNMQyxJQUFJLEVBQUVKLHdCQUF3QjtJQUM5QkssT0FBTyxFQUFFO01BQUVGLGdCQUFnQixFQUFoQkE7SUFBaUI7RUFDOUIsQ0FBQztBQUNIIn0=